module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/6@2x_9ee1d3b83ef27bd372b53518501541bf.png";